// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-c88d3cee] .atwho-panel{top:0!important}", "",{"version":3,"sources":["webpack://./resources/js/components/tarefas/imports/Cartao.vue"],"names":[],"mappings":"AAEI,+BACI,eADR","sourcesContent":["\n::v-deep {\n    .atwho-panel {\n        top: 0 !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
